export default class Date extends React.PureComponent
  render: ->
    <p className="date" title={@props.item.formattedDate}>
      {@props.item.timeAgo}
    </p>
